export default function skip(array, count) {
    return array.slice(count);
}
